<script setup lang="ts">
import { NoResultsProps } from "./NoResults.props"

defineProps<NoResultsProps>()

const { locale } = useI18n()
const isLoading = ref(true)

const { overflowAuto, overflowHidden } = useBodyOverflowManager()

const { data, error, pending } = usePage(
  `/api/gluon/fetchNoResultPage/${locale.value}/no_results.js`,
  {
    lazy: true
  }
)

if (error.value) {
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}

const pageData = computed(() => data.value)

const {
  data: trendingProducts,
  pending: pendingTrendingProducts,
  error: errorTrendingProducts
} = useLazyFetch<any>(`/api/algolia/getRecommendations/recommend-5/param`, {
  server: false
})

const suggestionProducts = useAlgoliaMappedProducts(trendingProducts)

onMounted(() => {
  overflowHidden()

  useTimeoutFn(() => {
    isLoading.value = false
    overflowAuto()
  }, 1500)
})
</script>

<template>
  <div>
    <SkeletonNoResult v-if="isLoading" />
    <div v-else class="wrapper-no-results grid-standard">
      <TextBlocksEmpty
        type="productNotFound"
        class="col-span-full"
        :product="product"
      />
      <SuggestionsRelatedSearch
        key="suggestionsRelatedSearch"
        class="col-span-full"
        :title="$t('suggested.relatedSearch.title')"
      />
      <RailsProduct
        v-if="
          suggestionProducts &&
          !pendingTrendingProducts &&
          !errorTrendingProducts
        "
        :title="$t('rails.product.mostSold')"
        typeCard="MostSold"
        :suggestedCards="suggestionProducts"
        backgroundColor="grey"
        class="negative-margined col-span-full mt-6 md:mt-9"
      />
      <DynamicContent
        v-if="pageData.content && !pending"
        class="cms-content negative-margined col-span-full"
        :components="pageData.content"
      />
      <SuggestionsPopularSearch
        class="col-span-full"
        :title="$t('suggested.relatedSearch.popularQueries')"
      />
    </div>
  </div>
</template>
